export default function () {
    var ariaTenantTokens = [
        '56468f6991c348029c6bba403b444607-7f5d6cd1-7fbe-4ab1-be03-3b2b6aeb3eb4-7696',
    ];
    if (window && window.bootstrapDiagnostics && window.bootstrapDiagnostics.fost == 'namprd00') {
        ariaTenantTokens[0] =
            '423194e6b1ad4b87ad08c8fe8c1e43cf-cd9607cb-f22b-4bff-891e-d50c228129d8-7725';
    }
    return {
        ariaTenantTokens: ariaTenantTokens,
        flightControls: {
            client_event: 'an-client-event',
            sampled_client_event: 'an-sampled-client-event',
            client_error: 'an-client-error',
            client_verbose: 'an-client-verbose-wl',
            client_network_request: 'an-client-network-request',
            client_qos_success: '*',
            client_qos_failure: '*',
            Owa_PageLoadTime: '*',
        },
        expectedSampleRate: {
            client_event: 100,
            sampled_client_event: 5,
            client_error: 100,
            client_verbose: 1,
            client_network_request: 0.1,
            client_qos_success: 100,
            client_qos_failure: 100,
            Owa_PageLoadTime: 100,
        },
        verboseWhiteListEvents: ['AttachmentRefreshDownloadToken'],
    };
}
//# sourceMappingURL=getMailAnalyticOptions.js.map